import { Box, Typography, Button, Chip } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import { useNavigate } from 'react-router-dom';
import LogoVeles from '../../../../../../assets/img/Logo Vetorizado Veles Colorido.png';
import { useDossieService } from '../../../../../../use-cases/dossie';

export const DossieHeader = ({
  isPF,
  docFormatado,
}: {
  isPF: boolean;
  docFormatado: string;
}) => {
  const navigate = useNavigate();
  const { fecharOrigemConsulta } = useDossieService();

  return (
    <Box className="dossie-header avoid-break" p={{ xs: 2.5, sm: 3.5, md: 4 }} pb={{ xs: 2, md: 2.5 }}>
      {/* 1. Top Bar na Tela (Oculto na Impressão) */}
      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2} mb={3} className="no-print">
        <Chip
          icon={<PersonOutlineIcon sx={{ fontSize: '16px !important', color: '#68457c !important' }} />}
          label={isPF ? "CONSULTA CPF" : "CONSULTA CNPJ"}
          size="small"
          sx={{ backgroundColor: '#e9deef', color: '#68457c', fontWeight: 700, borderRadius: '8px', px: 0.5 }}
        />
        <Box display="flex" gap={1.5}>
          <Button
            onClick={() => window.print()}
            startIcon={<PictureAsPdfOutlinedIcon sx={{ fontSize: 18 }} />}
            sx={{
              color: '#fff',
              backgroundColor: '#723989',
              borderRadius: '100px',
              px: 2.5,
              py: 0.75,
              textTransform: 'none',
              fontWeight: 700,
              boxShadow: '0 4px 12px rgba(114, 57, 137, 0.25)',
              '&:hover': { backgroundColor: '#5c2d6e', boxShadow: '0 6px 16px rgba(114, 57, 137, 0.35)' }
            }}
          >
            Salvar em PDF
          </Button>
          <Button
            onClick={() => {
              fecharOrigemConsulta();
              navigate('/private/dossie/search');
            }}
            startIcon={<ArrowBackIcon sx={{ fontSize: 18 }} />}
            sx={{
              color: '#68457c',
              backgroundColor: '#f3eff7',
              borderRadius: '100px',
              px: 2.5,
              py: 0.75,
              textTransform: 'none',
              fontWeight: 700,
              '&:hover': { backgroundColor: '#e9deef' }
            }}
          >
            Voltar à Pesquisa
          </Button>
        </Box>
      </Box>

      {/* 2. Banner Oficial com Logo (Exclusivo para Impressão / PDF) */}
      <Box className="dossie-print-banner print-only" sx={{ display: 'none' }} justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            component="img"
            src={LogoVeles}
            alt="Veles Logo"
            className="dossie-logo"
            sx={{
              height: 40,
              objectFit: 'contain',
            }}
          />
          <Box>
            <Typography variant="overline" sx={{ color: '#723989', fontWeight: 800, letterSpacing: '0.08em', display: 'block', lineHeight: 1.2 }}>
              DOSSIÊ VELES
            </Typography>
            <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600 }}>
              Dossiê Cadastral e Análise de Crédito
            </Typography>
          </Box>
        </Box>

        <Chip
          icon={<PersonOutlineIcon sx={{ fontSize: '16px !important', color: '#68457c !important' }} />}
          label={isPF ? "CONSULTA CPF" : "CONSULTA CNPJ"}
          size="small"
          sx={{ backgroundColor: '#e9deef', color: '#68457c', fontWeight: 700, borderRadius: '8px', px: 0.5 }}
        />
      </Box>

      {/* Título com Documento */}
      <Box sx={{ borderTop: '1px solid #f0ebf5', pt: 2, mb: 1 }}>
        <Typography
          variant="overline"
          sx={{
            color: '#723989',
            fontWeight: 800,
            letterSpacing: '0.08em',
            fontSize: '0.85rem',
            display: 'block',
            lineHeight: 1.2,
            mb: 0.5,
          }}
        >
          DOSSIÊ VELES
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a1a2e', mb: 1.5, fontSize: { xs: '1.25rem', md: '1.45rem' } }}>
          Resultado da pesquisa para o {isPF ? 'CPF' : 'CNPJ'}: <span style={{ color: '#723989' }}>{docFormatado}</span>
        </Typography>

        <Box display="flex" flexWrap="wrap" gap={3} alignItems="center">
          <Box display="flex" alignItems="center" gap={1}>
            <CalendarTodayOutlinedIcon sx={{ color: '#723989', fontSize: 16 }} />
            <Typography variant="caption" sx={{ color: '#475569', fontWeight: 600 }}>
              Consulta realizada em {new Date().toLocaleDateString('pt-BR')} às {new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <FileCopyOutlinedIcon sx={{ color: '#723989', fontSize: 16 }} />
            <Typography variant="caption" sx={{ color: '#475569', fontWeight: 600 }}>
              Tipo: Crédito Veles {isPF ? 'PF' : 'PJ'}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <LockOutlinedIcon sx={{ color: '#e6a822', fontSize: 16 }} />
            <Typography variant="caption" sx={{ color: '#475569', fontWeight: 600 }}>
              Dados protegidos pela LGPD (Lei nº 13.709/2018)
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
